import React, { createContext, useContext, useEffect, useMemo } from "react";
import SocketController from "./socket.controller"; // Adjust the import path as needed

const SocketContext = createContext<SocketController | null>(null);

export const SocketProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const controller = useMemo(() => new SocketController(), []);

  useEffect(() => {
    // Any other initialization logic can go here
    console.log("SocketProvider mounting");
    // Cleanup function to run on component unmount
    return () => {
      console.log("SocketProvider unmounting");
      controller.disconnect();
    };
  }, [controller]);

  return (
    <SocketContext.Provider value={controller}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (context === null) {
    throw new Error("useSocket must be used within a SocketProvider");
  }
  return context;
};
